
import { Options, Vue } from 'vue-class-component'
import 'leaflet/dist/leaflet.css'
import L, { LatLngTuple } from 'leaflet'
import { getMedia, MediaData, MediaFilter } from '@/api'
import { LMap, LMarker, LPopup, LTileLayer } from '@vue-leaflet/vue-leaflet'
import ModalLink from '@/components/ModalLink.vue'
import ContentModal from '@/components/ContentModal.vue'
import ContentRef from '@/components/ContentRef.vue'

// https://github.com/Leaflet/Leaflet/issues/4968
// ...
type D = L.Icon.Default & {
  _getIconUrl?: string;
}
delete (L.Icon.Default.prototype as D)._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

class GroupedMediaData {
  n!: number
  latLng!: LatLngTuple
  media!: MediaData[]
}

@Options({
  components: {
    ContentRef,
    ModalLink,
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  props: {
    id: Number,
    name: String,
    latitude: Number,
    longitude: Number,
    zoom: Number,
    filter: MediaFilter
  }
})
export default class TownMap extends Vue {
  groupedMediaData: Map<string, GroupedMediaData> = new Map()
  map!: L.Map

  id!: number
  filter!: MediaFilter
  name!: string
  latitude!: number
  longitude!: number
  zoom!: number

  handlePopupClick (item: MediaData, latlng: LatLngTuple): void {
    if (this.$parent) (this.$parent.$refs.mainContentModal as ContentModal).setContent(item.id, item.type, item.title, latlng, JSON.parse(item.data))
  }

  groupAndPlaceMarkers (list: MediaData[]): void {
    const tmpMap: Map<string, GroupedMediaData> = new Map()
    let n = 1
    for (const media of list) {
      const key = [media.latitude, media.longitude].join(',')
      if (!tmpMap.has(key)) {
        tmpMap.set(key, {
          n: n,
          latLng: [media.latitude, media.longitude],
          media: []
        })
      }
      const v = tmpMap.get(key)
      if (v) v.media.push(media)
      n++
    }
    this.groupedMediaData = tmpMap
  }

  dateFormat (date: Date): string {
    return new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(date)
  }

  drawMap (): void {
    getMedia(this.id, this.filter).then(res => {
      this.groupAndPlaceMarkers(res)
    }).catch(() => {
      // todo
    })
  }

  filterUpdate (filter: MediaFilter): void {
    getMedia(this.id, filter).then(res => {
      this.groupAndPlaceMarkers(res)
    }).catch(() => {
      // todo
    })
  }

  beforeCreate (): void {
    this.filter.addListener((filter) => {
      this.filterUpdate(filter)
    })
  }

  mounted (): void {
    this.drawMap()
  }

  updated (): void {
    // Possible leaflet or vue-leaflet bug:
    // Sometimes map center is not correctly set when updating to another location
    const map = (this.$refs.leafletTownMap as LMap).leafletObject
    map.setView([this.latitude, this.longitude])
    this.drawMap()
  }

  beforeUnmount (): void {
    if (this.map) {
      this.map.remove()
    }
  }
}
